export const environment = {
  production: true,
  graphql: {
    uri: 'https://api.iqd-pro.com/graphql',
  },
  sentry: {
    dsn: 'https://5374718b166d4968a788fb8793de1d9e@sentry.io/1520262',
    enabled: true,
  },
  gtm: {
    id: 'GTM-WH899QZ6',
    enabled: true,
  },
};
